angular.module('bribac.translations.kr', [])

  .constant('KR_TRANSLATIONS', {

    today: "Today",
    scheduled_test: "Scheduled test",
    optional_test: "Optional test",

    bacUnits: {
      short: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰',
        BAC_PERCENT: '%'
      },
      long: {
        BRAC: 'brAC',
        BAC_PER_MILLE: '‰ (per mille)',
        BAC_PERCENT: '% (percent)'
      }
    },

    boolean: {
      yes: 'Yes',
      no: 'No',
    },

    components: {
      agentDetails: {
        role: '역할',
        fullAddress: '주소',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: '휴대폰 번호',
        email: '이메일 주소',
        status: '상태',
      },

      agentEditor: {
        firstName: '이름',
        lastName: '성',
        phone: '휴대폰 번호',
        email: '이메일 주소',
        streetAddress: '주소',
        postalCode: '우편번호',
        city: '도시',
        organization: '기관',
        roleHeading: '역할',
        notAllowedToChangeRole: '관리자 설정 변경 권한이 없습니다.',
        systemLanguageHeading: '시스템 언어',
        groupsHeading: '소속 그룹',
        mustChooseOrganizationBeforeGroups: '소속그룹 선택 전 기관을 먼저 선택해야 합니다.',
        canOnlySetGroupsOfOwnOrganization: '관리자가 동일한 기관에 소속된 경우에만 모니터링 대상 그룹 설정이 가능합니다. 당신이 소속된 기관은 {{name}} 입니다.',
        thisGroupDoesntHaveAnySubGroups: '본 소속 그룹에 설정된 하위 그룹은 존재하지 않습니다.',
        agentSettingsHeading: '관리자 세팅',
        notifyAgentUsing: '관리자 통지 방법',
        deleteAgent: '삭제',
      },

      collapsingBox: {
        expand: '펼치기',
        collapse: '숨기기',
      },

      ibacDetails: {
        macAddress: 'MAC address',
        lastUsed: '마지막 측정',
        lastCalibrated: '마지막 보정',
        cycles: '주기',
        cyclesLeftUntilMaintenance: '유지보수까지 잔여 주기',
        daysLeftUntilMaintenance: '유지보수까지 잔여 일',
        showDetails: '자세히 보기',
        lastLocation: '마지막 측정위치',
        locationNotAvailable: '마지막 측정위치 정보가 유용하지 않습니다.',
        status: '상태',
        editIbac: '음주측정기 단말기 편집',
        batteryCharge: '배터리 충전',
        batteryEstimation: '잔여 사용시간',
        assignedToSubject: '측정 대상자 선정'
      },

      ibacEditor: {
        macAddress: 'MAC address',
        organization: '기관',
      },

      mainGroupEditor: {
        name: '소속그룹 명',
      },

      mainGroupOverview: {
        thereAreNoSubGroupsInName: '{{name}} 에 설정된 하위 그룹은 존재하지 않습니다.',
      },

      mainMenu: {
        home: 'Home',
        add: '추가',
        templates: '운영설정 양식',
        groups: '소속그룹',
        search: '검색',
        myProfile: '사용자 프로필',
        ibac: '음주측정기',
        organizations: '기관',
        notes: '메모',
        reports: '보고서',
        logOut: '로그 아웃',
        alerts: '경고'
      },

      mainGroupSubGroupPicker: {
        noGroupsInOrganization: "조직에 그룹이 없습니다."
      },

      messageEditorModal: {
        sendSmsToFullName: '{{fullName}} 에게 문자메세지 전송하기',
        theSmsWasSentToFullName: '{{fullName}} 에게 문자메세지 전송 완료',
        characters: '문자',
        cancel: '취소',
        close: '닫기',
        sendTheSms: '문자메세지 전송',
      },

      samplesChartModal: {
        samplesForFullName: '{{fullName}} 음주측정 결과',
        chosenDateFrom: '시작일 선택',
        chosenDateTo: '종료일 선택',
        back: '뒤로 가기'
      },

      noteEditor: {
        text: '텍스트 삽입',
      },

      optionalSampleOverview: {
        passedOnDate: '음주측정 통과 {{dateCreated | date:"short"}}',
        failedOnDate: '음주측정 허용치 초과 {{dateCreated | date:"short"}}',
      },

      organizationDetails: {
        organizationalNumber: '기관 관리번호',
        licenseType: '라이선스 형태',
        bacUnit: '음주측정 단위',
        settings: '설정 현황',
        messageSupport: '측정대상자에게 메시지 전송 가능',
        noteSupport: '전송 메시지에 메모 삽입 가능',
        randomTests: '무작위 음주측정 설정 및 일정 설정 가능',
        roleManagement: '관리자 역할 선별적 부여 가능',
        status: '상태',
      },

      organizationEditor: {
        name: '기관 명',
        organizationalNumber: '기관 관리번호',
        bacUnitHeading: '음주측정 단위',
        licenseTypeHeading: '라이선스 형태',
        settingsHeading: '설정 현황',
        cantConfigSettingsForNewOrg: '신규 기관 등록 중에는 설정이 불가능합니다.',
        messageSupport: '측정대상자에게 메시지 전송 가능',
        noteSupport: '전송 메시지에 메모 작성 가능',
        randomTests: '무작위 음주측정 설정 및 일정 설정 가능',
        roleManagement: '관리자 역할 선별적 부여 가능',
      },

      ruleSetDetails: {
        alcoholLimit: '알코올 허용 수치',
        testExpiresAfter: '측정 허용시간',
        testExpiresAfterSecondsValue: '{{testExpiresAfterSeconds / 60}} min',
        showResultsToSubject: '측정 대상자에게 결과 통지',
        notifyMonitorsWhen: '모니터링 알림 대상 이벤트 설정',
        notifySubjectsUsing: '통지 방법',
        gpsRequired: 'GPS 위치 정보 기록'
      },

      ruleSetEditor: {
        name: '성명',
        testExpiresAfterSecondsUnit: 'seconds',
        saveTemplateCopy: '운영 설정 양식으로 사본 저장',
        templatesReuse: '운영설정 양식은 다른 측정 대상자에게도 적용할 수 있습니다.',
        alcoholLimit: '알코올 허용 수치',
        cancel: '취소',
        saveSettings: '설정 저장',
        savingSettings: '설정 저장 중',
        testExpiresAfter: '측정 허용시간',
        showResultsToSubject: '측정 대상자에게 결과 통지',
        notifyMonitorsWhen: '모니터링 알림 대상 이벤트 설정',
        notifySubjectsUsing: '알림 전송 방법 설정',
        gpsRequired: 'GPS 위치 정보 기록',
        deleteTestDataAfterDays:"(일 수 후) 테스트 데이터를 삭제",
        deleteTestDataAfterDays_doNotDelete:"없음"
      },

      scheduleDetails: {
        weekdays: '측정 요일',
        randomTests: '무작위 측정',
        perDay: '일별 측정 횟수',
        betweenTimes: '시간대',
        fixedTests: '고정 측정',
      },

      scheduleEditor: {
        whichDaysHeading: '측정 요일',
        randomTestHeading: '무작위 측정',
        randomTestsWillOccurBetweenTheseTimes: '무작위 측정 시간대',
        scheduledTestHeading: '측정 일정',
        howManyTestsADayAndWhichTimes: '일별 측정횟수 및 시간',
        removeTimeButton: '제거',
        addTimeButton: '시간 추가',
        cancelButton: '취소',
        saveButton: '일정 저장',
        savingButton: '일정 저장 중',
        labels: {
          name: 'Name',
          template: '운영 설정 양식으로 사본 저장',
          templateDescription: '운영설정 양식은 다른 측정 대상자에게도 적용할 수 있습니다.',
          maxRandomTestsPerDay: '일별 무작위 측정 최대 횟수',
          zeroTestDescription: '0 설정 시 무작위 측정 해제',
          minSecBetweenRandomTests: '무작위 측정 간 최소 시간',
          earliest: '시작 시간',
          latest: '종료 시간',
        },
      },

      schedulePeriodDetails: {
        schedule: '일정',
        activePeriod: '활성화 기간',
        period: '{{startDate | date:"shortDate"}} - {{endDate | date:"shortDate"}}',
      },

      schedulePeriodEditor: {
        cancelButton: '취소',
        saveButton: '일정 저장',
        savingButton: '일정 저장 중',
        labels: {
          startDate: '시작일',
          endDate: '종료일',
        },
      },

      externalMonitorDetails: {
        labels: {
          name: '성명',
          phone: '휴대폰 번호',
          email: '이메일 주소',
          fillAtleastOne: '최소 하나이상 기입 필수'
        }
      },

      externalMonitorEditor: {
        cancelButton: '취소',
        saveButton: '외부 모니터링 인원 저장'
      },

      searchForm: {
        submitButton: '검색',
        labels: {
          query: '시스템 내 검색',
        },
      },

      subGroupEditor: {
        labels: {
          name: '하위그룹 명',
        },
      },

      subGroupOverview: {
        noSubjectsInSubGroup: '{{name}} 에 등록된 측정 대상자가 존재하지 않습니다.',
      },

      subjectDetails: {
        group: '소속그룹',
        subGroupInMainGroup: ' in ',
        fullAddress: '주소',
        fullAddressValue: '{{address}}, {{postalCode}}, {{city}}',
        phone: '휴대폰 번호',
        email: '이메일 주소',
        timeZone: '시간대',
        highlighted: '주요 감시 대상',
        hasInsurance: '보험 있음',
        ssn: '주민등록번호(앞자리6번호)',
        status: '상태',
        photo: '대상자 사진',
      },

      subjectEditor: {
        groupHeading: 'Group',
        mainGroupHeading: '소속 그룹',
        subGroupHeading: '하위 그룹',
        chooseMainGroupBeforeSubGroup: '먼저 소속 그룹을 선택하세요.',
        systemLanguageHeading: '시스템 언어',
        ruleSetHeading: '음주측정기 세팅',
        editRuleSetButton: '편집',
        removeRuleSetButton: '제거',
        cancelRuleSetButton: '취소',
        useRuleSetButton: '운영 설정',
        subjectDoesntHaveAnyRuleSets: '측정 대상자의 사용 설정이 지정되지 않았습니다.',
        addNewRuleSetButton: '신규 운영설정 추가',
        addRuleSetFromTemplateButton: '양식을 통한 운영설정 추가',
        addNewRuleSetHeading: '신규로 대상자 음주측정기 설정 추가',
        addRuleSetFromTemplateHeading: '설정양식을 통한 대상자 음주측정기 설정 추가',
        editTheCurrentRuleSetHeading: '현재 음주측정기 설정 편집',
        schedulesHeading: '일정',
        editScheduleButton: '편집',
        removeScheduleButton: '제거',
        subjectDoesntHaveAnySchedules: '설정된 측정일정이 존재하지 않습니다.',
        addNewScheduleButton: '신규 측정일정 추가',
        addScheduleFromTemplateButton: '설정양식을 통한 측정일정 추가',
        addNewScheduleHeading: '신규로 대상자 측정일정 추가',
        addScheduleFromTemplateHeading: '설정양식을 통한 대상자 측정일정 추가',
        editingSchedule: '일정 편집 {{name}}',
        saveSubjectButton: '측정 대상자 저장',
        savingSubjectButton: '측정 대상자 저장 중',
        crisisAgentHeading: '감시 관리자',
        externalMonitorsHeading: '외부 모니터링 인원',
        addNewExternalMonitorButton: '신규 외부 모니터링 인원 추가',
        editExternalMonitor: '외부 모니터링 인원 편집',
        deleteExtMonitorQuestion: '선택한 외부 모니터링 인원을 정말 삭제하시길 원하십니까?',
        subjectNoExternalMonitors: '{{firstName}} 지정된 외부 모니터링 요원이 존재하지 않습니다.',
        labels: {
          firstName: '이름',
          lastName: '성',
          ssn: '주민등록번호',
          address: '주소',
          postalCode: '우편번호',
          city: '도시',
          phone: '휴대폰 번호',
          email: '이메일 주소',
          timeZone: '시간대',
          highlighted: '주요 감시',
          pauseScheduledTests: '예정된 음주측정 중단',
        },
        assignedIbac: '할당된 음주측정기',
      },

      subjectOverview: {
        highlighted: '주요 감시대상',
        scheduledTestsArePaused: '예정된 음주측정이 중단되었습니다.',
        sendMessageButton: '메세지',
        showProfileButton: '프로필 보기',
      },

      testDetails: {
        testPassed: '음주측정 통과 성공',
        testHasNotStartedYet: '음주측정이 아직 실행되지 않았습니다.',
        startsOn: '음주측정 시작',
        expiresOn: '음주측정 시간만료',
        allowedAlcoholValue: '허용된 알코올 수치',
        submittedAlcoholValue: '제출된 알코올 수치',
        testOpen: '음주측정 오픈',
        waitingForSampleToBeHandedIn: '음주측정 결과 수신 대기 중',
        testFailed: '음주측정 통과 실패',
        noSampleWasHandedIn: '제출된 음주측정 결과가 없습니다.',
        theSampleExceededTheAllowedAlcoholLimit: '제출된 음주측정 결과가 허용 수치를 초과하얐습니다.',
        sampleTakenOn: '음주측정 결과 수신',
        deviceColor: '음주측정 인증 컬러',
        showLocationOnMap: '위치정보 지도 펼치기',
        hideLocationOnMap: '위치정보 지도 감추기',
        showProfileButton: '프로필 보기',
        locationNotAvailable: '위치정보가 유효하지 않습니다.',
        feeling: '기분',
        RED: "빨강",
        BLUE: "파랑",
        PINK: "분홍",
        GREEN: "초록"
        // optionalTest: '본 음주측정 결과는 예정되거나 무작위 음주측정이 아닌 대상자 임의로 측정 결과입니다.',
        // theSampleWasHandedInOutsideOfTheAllowedLocation: '본 결과는 허용된 위치에서 벗어나 측정된 수치입니다.',
      },

      testOverview: {
        opensOnDate: '음주측정 개시 {{opensOnDate | date:"short"}}',
        passedOnDate: '통과 {{dateCreated | date:"short"}}',
        failedOnDate: '실패  {{dateCreated | date:"short"}}',
        expiresOnDate: 'Expired on {{expiresOnDate | date:"short"}}',
        pendingNoSampleHasBeenHandedInYet: '측정결과 수신대기 중,음주측정 결과가 아직 제출되지 않았습니다.',
        failedNoSampleWasHandedIn: '측정결과 수신 실패, 음주측정 결과가 제출되지 않았습니다.',
      },

      whenLoaded: {
        loading: '로딩중…',
      },

      activation: {
        activateButton: '활성화',
        deactivateButton: '비활성화',
      },
      imageMultiSelect: {
        notFound: '찾을 수 없음',
        selectAll: '모두 선택',
        unselectAll: '선택 취소',
      },
      boostImageEditor: {
        header: '부스트 이미지'
      }
    },

    EXCEPTIONS: {
      MULTIPLE_OPEN_TESTS: '{{firstName}} 이미 음주측정이 요청되었습니다.'
    },

    "Internal Server Error":"문제가 발생했습니다. 다시 시도해보시고 계속 문제가 발생되면 고객지원센터에 문의하시기 바랍니다.",
    formErrors: {
      invalidFields: "입력 정보가 잘못되었거나 누락되었습니다. 다시한번 입력값을 확인하시기 바랍니다.",
      required: '입력 필수사항',
      minlength: '최소 입력 문자열 {{minLength}} ',
      maxLength: '최대 입력 문자열 {{maxLength}} ',
      invalidEmailAddress: '유효하지 않은 이메일 주소',
      invalidPhoneNumber: '전화 번호는 숫자와 공백 만 포함 할 수 있으며 국가 코드로 시작해야합니ek. 예를 들어, +82 10 1234 5678',
      invalidPassword: '암호는 8 자 이상이어야하며 A에서 Z까지의 문자와 0에서 9까지의 숫자 만 포함 할 수 있습니다.',
      invalidDateOfBirth: '생년월일은 YYYY-MM-DD (년-월-일) 형식이어야 합니다. 예를 들어, 1980-01-01',
      invalidMacAddress: '유효하지않은 MAC address 형식',
      invalidSSN: '주민등록번호는 앞자리 6자리 숫자로만 입력 가능합니다. ',
      outsideInterval: '최소값은 5분이고 최대값은 720분입니다.',
      invalidPhoto: '지원되지 않는 이미지 파일 형식입니다.',
      hasToBeNumber: '알코올 허용 수치는 숫자여야만 합니다.',
      minBacLimitValue: '크거나 또는 동일한 수치를 입력하세요 {{minBacLimitValue}}.',
      maxBacLimitValue: '작거나 또는 동일한 수치를 입력하세요 {{maxBacLimitValue}}.',
      earliestAfterLatest: '시작시간은 종료시간 이 후로 설정할 수 없습니다.'
    },

    licenseTypes: {
      PRO: 'Pro',
      'PRO GROUP': 'Pro group'
    },

    locales: {
      en: 'English',
      sv: 'Swedish',
      ko: '한국인',
    },

    months: {
      'JAN': '1월',
      'JAN.short': '1월',
      'FEB': '2월',
      'FEB.short': '2월',
      'MAR': '3월',
      'MAR.short': '3월',
      'APR': '4월',
      'APR.short': '4월',
      'MAY': '5월',
      'MAY.short': '5월',
      'JUN': '6월',
      'JUN.short': '6월',
      'JUL': '7월',
      'JUL.short': '7월',
      'AUG': '8월',
      'AUG.short': '8월',
      'SEP': '9월',
      'SEP.short': '9월',
      'OCT': '10월',
      'OCT.short': '10월',
      'NOV': '11월',
      'NOV.short': '11월',
      'DEC': '12월',
      'DEC.short': '12월'
    },

    notificationEvents: {
      testPassed: '통과',
      testFailed: '실패',
      optionalTestPassed: '대상자 임의측정 통과',
      optionalTestFailed: '대상자 임의측정 실패',
      testExpired: '측정 시간 초과'
    },

    notificationMethods: {
      sms: '문자메세지',
      email: '이메일',
      push: '푸쉬메세지',
    },

    units: {
      minute: {
        short: '분',
        long: '분',
      },
    },

    roles: {
      ROLE_SUPER_ADMIN: '슈퍼관리자',
      ROLE_ADMIN: '관리자',
      ROLE_GROUP_ADMIN: '그룹 관리자',
      ROLE_SUBJECT: '측정 대상자',
    },

    views: {
      404: {
        heading: 'Error 404, 페이지를 찾을 수 없습니다.',
        homeLink: '시작페이지로 이동',
      },

      addAgent: {
        heading: '관리자 추가',
        save: '설정 저장',
        saving: '설정 저장 중',
        addedHeading: '추가된 관리자',
        nothingAdded: '신규로 추가된 관리자가 존재하지 않습니다.',
      },

      addGroup: {
        mainGroupHeading: '소속그룹 추가',
        saveMainGroup: '소속그룹 저장',
        savingMainGroup: '소속그룹 저장 중',
        addedMainGroupsHeading: '추가된 소속그룹',
        noMainGroupsAdded: '추가된 소속그룹이 존재하지 않습니다.',
        subGroupHeading: '하위그룹 추가',
        chooseMainGroupToAddSubGroups: '하위그룹을 추가할 소속그룹을 먼저 선택하세요.',
        saveSubGroup: '하위그룹 저장',
        savingSubGroup: '하위그룹 저장 중',
        addedSubGroupsInMainGroupHeading: '{{name}}에 추가된 하위그룹',
        noSubGroupsAdded: '추가된 하위그룹이 존재하지 않습니다.',
      },

      addIbac: {
        heading: '음주측정기 등록',
        save: '음주측정기 저장',
        saving: '음주측정기 저장 중',
        addedHeading: '등록된 음주측정기',
        nothingAdded: '신규로 등록된 음주측정기가 존재하지 않습니다.',
      },

      addOrganization: {
        heading: '소속기관 등록',
        save: '소속기관 저장',
        saving: '소속기관 저장 중',
        addedHeading: '등록된 소속기관',
        nothingAdded: '신규로 등록된 소속기관이 존재하지 않습니다.',
      },

      addRuleSet: {
        heading: '운영설정 양식 등록',
        addedHeading: '등록된 운영설정 양식',
        nothingAdded: '신규로 등록된 운영설정 양식이 존재하지 않습니다.',
      },

      addSchedule: {
        heading: '운영일정 양식 추가',
        addedHeading: '등록된 운영일정 양식',
        nothingAdded: '신규로 등록된 운영일정 양식이 존재하지 않습니다.',
      },

      addSubject: {
        heading: '측정 대상자 등록',
        addedHeading: '등록된 음주측정 대상자',
        nothingAdded: '신규로 등록된 음주측정 대상자가 존재하지 않습니다.',
      },

      add: {
        peopleOrGroupsHeading: '소속그룹 및 인원 등록',
        planTemplatesHeading: '관리설정 양식 등록',
        organizationsHeading: '소속기관 및 음주측정기 등록',
        agent: '관리자',
        subject: '측정 대상자',
        group: '소속그룹',
        schedule: '측정 일정 양식',
        settings: '운영 설정 양식',
        organization: '기관',
        ibac: '음주측정기'
      },

      alerts: {
        noAlerts: '없음{{filterToPrint}}'
      },

      editAgent: {
        heading: '{{fullName}} 프로필 편집',
        save: '설정 저장',
        saving: '설정 저장 중',
      },

      editMainGroup: {
        heading: '{{name}}편집',
        save: '소속그룹 저장',
        saving: '소속그룹 저장 중',
      },

      editOrganization: {
        heading: '{{name}} 편집',
        save: '소속기관 저장',
        saving: '소속기관 저장 중',
      },

      editRuleSet: {
        heading: '{{name}} 편집',
      },

      editSchedulePeriod: {
        heading: '{{schedulePeriod}} 편집 for {{subject}}',
      },

      editSchedule: {
        heading: '{{name}} 편집',
      },

      editSubGroup: {
        heading: '{{name}} 편집',
        save: '하위그룹 저장',
        saving: '하위그룹 저장 중',
      },

      editSubject: {
        heading: '{{fullName}} 편집',
      },

      editIbac: {
        heading: '{{macAddress}} 편집',
        cancel: '취소',
        saveEvent: '이벤트 저장',
        addNewEvent: '신규 이벤트 저장',
        editEvent: '이벤트 편집',
        removeEvent: '이벤트 제거',
        activate: '활성화',
        deactivate: '비활성화',
        activateAt: '활성화',
        deactivateAt: '비활성화',
        setEventAndType: '이벤트 형태와 일정 설정',
        noEvents: '예정된 이벤트가 없습니다.',
        deleteEventQuestion: '본 이벤트를 정말 제거하실 것입니까?',
        eventsOfIbac: '음주측정기 이벤트',
        eventType: '이벤트 형태',
        eventTime: '이벤트 일정',
        required: '입력 필수사항',
      },

      forgotPassword: {
        heading: '비밀번호 분실',
        resetEmailSentTitle: '요청 접수',
        resetEmailSentDescription: '{{email}} 주소로 비밀번호 재설정 링크가 포함된 이메일이 발송되었습니다.',
        labels: {
          email: '이메일',
        },
        submitButton: '신규 비밀번호 요청',
        backToLogin: '로그인화면 돌아가기',
      },

      home: {
        filtersHeading: '모니터링 대상',
        allGroupsFilter: '모든 그룹',
        highlightedSubjectsFilter: '주요 감시 대상자',
        noHighlightedSubjects: '모니터링 대상 그룹에 주요 감시 대상자로 설정된 대상자가 존재하지 않습니다.',
        inactiveSubjectsFilter: '비활성화 음주측정 대상자',
        noInactiveSubjects: '모니터링 대상 그룹에 활성화된 대상자가 존재하지 않습니다.'
      },

      listAgents: {
        heading: '관리자',
      },

      listOrganizations: {
        heading: '소속기관',
        noActiveOrganizations: '활성화된 소속기관이 없습니다.',
        noInactiveOrganizations: '비활성화된 소속기관이 없습니다.',
        sortByName: '소속기관 명에 따른 분류'
      },

      listRuleSets: {
        heading: '운영설정 양식',
      },

      listSchedules: {
        heading: '측정일정 양식',
      },

      listSubjects: {
        heading: '음주측정 대상자',
      },

      listIbacs: {
        heading: '음주측정기',
        noIbacs: '음주측정기가 없습니다.',
        noActiveIbacs: '활성화된 음주측정기가 없습니다.',
        noInactiveIbacs: '비활성화된 음주측정기가 없습니다.',
        noTamperedIbacs: '변조된 음주측정기가 없습니다.',
      },

      listAlerts: {
        heading: '음주관리운영 이벤트 모니터링',
        dateHeading: 'Date',
        eventTypeHeading: '이벤트 종류',
        subjectNameHeading: '측정 대상자 이름',
        groupHeading: '소속그룹',
        ibacHeading: '음주측정기'
      },

      login: {
        heading: '음주관리시스템 관리자',
        labels: {
          email: '이메일',
          password: '비밀번호',
        },
        submitButton: '로그인',
        forgotPassword: '비밀번호 분실',
      },

      reports: {
        download: '다운로드',
        processing: '처리 중'
      },

      search: {
        heading: '검색',
        domains: {
          everything: '모든',
          subjects: '측정 대상자',
          agents: '관리자',
          mainGroups: '소속 그룹',
          subGroups: '하위 그룹',
        },
        subjectsHeading: '측정 대상자',
        noSubjectsFound: '측정 대상자를 찾을 수 없습니다.',
        agentsHeading: '관리자',
        noAgentsFound: '관리자를 찾을 수 없습니다.',
        mainGroupsHeading: '소속 그룹',
        noMainGroupsFound: '소속그룹을 찾을 수 없습니다.',
        subGroupsHeading: '하위 그룹',
        noSubGroupsFound: '하위그룹을 찾을 수 없습니다.',
      },

      setPassword: {
        invalidTokenHeading: 'Invalid password token.',
        goToLogin: '로그인 가기',
        heading: '비밀번호 선택',
        labels: {
          password: '비밀번호',
          confirmPassword: '비밀번호 확인'
        },
        passwordsDontMatch: '비밀번호가 일치하지 않습니다.',
        submitButton: '저장',
        passwordSavedHeading: '저장된 비밀번호',
        continueButton: '계속',
        subjectCanNowUseTheMobileApp: '이제 모바일앱을 사용하실 수 있습니다.',
      },

      singleAgent: {
        editAgent: '관리자 편집',
        editYourself: '프로필 편집',
      },

      singleMainGroup: {
        addSubGroups: '하위그룹 등록',
        editMainGroup: '소속그룹 편집',
        mainGroupDoesntHaveAnySubGroups: '본 소속그룹에는 하위그룹이 존재하지 않습니다.',
        subjectsCount: '{{length}} 측정 대상자',
        agentsCount: '{{length}} 관리자',
        seeWholeGroup: '전체 그룹 보기',
      },

      singleOrganization: {
        editOrganization: '소속기관 편집',
        downloadReportsHeading: '보고서 다운로드',
        startDate: '시작일',
        endDate: '종료일',
        ibacsHeading: '본 소속기관에 연결된 음주측정기',
        noIbacsInOrganization: '본 소속기관에 연결된 음주측정기는 없습니다.',
        noActiveIbacsInOrganization: '본 소속기관에 연결되어 있는 활성화된 음주측정기는 없습니다.',
        noInactiveIbacsInOrganization: '본 소속기관에 연결되어 있는 비활성화된 음주측정기는 없습니다.',
        ibacUsageReport: '음주측정기 사용',
        subjectUsageReport: '측정 대상자 사용',
        invoiceReport: '내역',
        invoiceDetailsReport: '상세 내역',
      },

      singleRuleSet: {
        editRuleSet: '운영설정 양식 편집',
      },

      singleSchedule: {
        editSchedule: '측정일정 양식 편집',
      },

      singleSubGroup: {
        subGroupInMainGroupHeading: '{{name}} in',
        editSubGroup: '하위그룹 편집',
        agentsHeading: '{{length}} 관리자',
        showProfile: '프로필 보기',
        subjectsHeading: '{{length}} 측정 대상자',
      },

      singleSubject: {
        subjectFirstNameHasNeverUsedTheMobileApp: '{{firstName}} 는 모바일앱을 사용한적이 없습니다.',
        instantNewTest: '즉시 음주측정 요청',
        editSubject: '측정 대상자 편집',
        immediateTestSuccess: '새로운 음주측정 요청이 생성되었고 {{firstName}}에게 통지되었습니다.',
        scheduledTestsHeading: '예정된 음주측정',
        scheduledTestsArePaused: '예정된 음주측정이 중단되었습니다.',
        editTheSubjectToResumeTheScheduledTests: '예정된 측정을 다시 시작하도록 측정 대상자를 편집하세요.',
        subjectFirstNameDoesntHaveAnyScheduledTestsYet: '{{firstName}} 은 아직 예정된 음주측정을 하지 않았습니다.',
        optionalAlcoholSamplesHeading: '대상자 임의 측정 결과',
        subjectFirstNameDoesntHaveAnyOptionalAlcoholSamplesYet: '{{firstName}} 대상자의 임의 측정결과를 아직 전달받지 못했습니다.',
        messagesHeading: 'SMS 문자메세지',
        subjectFirstNameHasNotReceivedAnyMessagesYet: '{{firstName}} 대상자는 아직 측정 요청 메세지를 수신하지 못했습니다.',
        newSmsMessage: '신규 문자메세지',
        showSamplesChart: '측정 결과 도표 보기',
        notesHeading: '메모',
        messageAuthor: '작성자',
        noteAuthor: '작성자',
        sent: '전송',
        created: '생성',
        edit: '편집',
        saveNote: '메모 저장',
        cancel: '취소',
        addNoteHeading: '메모 추가',
        saveNote: '메모 저장',
        savingNote: '메모 저장 중',
        settingsHeading: '음주측정기 설정',
        scheduleHeading: '일정',
        subjectFirstNameDoesntHaveAnySchedules: '{{firstName}} 대상자에 측정일정은 없습니다.',
        externalMonitorsHeading: '외부 모니터링 인원',
        subjectNoExternalMonitors: '{{firstName}} 대상자에 외부 모니터링 인원은 없습니다.',
        agents: '관리자',
        subjectNoAgents: '{{firstName}} 대상자에 관리자는 없습니다.',
        deleteSubject: '삭제',
      },

      templates: {
        heading: '운영설정 양식',
        menuItems: {
          schedule: '측정일정 양식',
          settings: '운영설정 양식',
        },
      }
    },

    weekdays: {
      'MON': '월요일',
      'MON.short': '월',
      'TUE': '화요일',
      'TUE.short': '화',
      'WED': '수요일',
      'WED.short': '수',
      'THU': '목요일',
      'THU.short': '목',
      'FRI': '금요일',
      'FRI.short': '금',
      'SAT': '토요일',
      'SAT.short': '토',
      'SUN': '일요일',
      'SUN.short': '일'
    },

    states: {
      'active': '활성화',
      'inactive': '비활성화',
      'tampered': '변조'
    },

    ibacFilter: {
      'all': '모든 음주측정기',
      'active': '활성화된 음주측정기',
      'inactive': '비활성화된 음주측정기',
      'tampered': '변조된 음주측정기'
    },

    organizationFilter: {
      'all': '모든 기관',
      'active': '활성화된 소속기관',
      'inactive': '비활성화된 소속기관'
    },

    alertFilter: {
      'all': '모두',
      'alerts': '경고',
      'violations': '위반'
    },

    violation: {
      optional_sample: "허용치 초과 임의측정 결과",
      test_expired: "측정 시간 초과",
      test_failed: "통과 실패"
    },

    alert: {
      ibac_tampered: "변조된 음주측정기",
      ibac_battery: "Low 배터리"
    },

    paging: {
      per_page_amount: "페이지별 결과",
      date_from_clean: "정리 시작일",
      date_to_clean: "정리 종료일"
    }

  })
